import { memo, type PropsWithChildren, useCallback, useState } from "react"

import { GeometryPickerOverlay } from "../../components/Overlays/GeometryPickerOverlay"
import { GeometryPickerContext } from "./context"
import type { GeometryPickerConfig } from "./typings"

interface GeometryPickerProviderProps extends PropsWithChildren {
	onOpenChange: (open: boolean) => void
}

export const GeometryPickerProvider = memo<GeometryPickerProviderProps>((props) => {
	const { children, onOpenChange } = props

	const [config, setConfig] = useState<GeometryPickerConfig | null>(null)

	const close = useCallback(() => {
		setConfig(null)
		onOpenChange?.(false)
	}, [onOpenChange])

	const open = useCallback(
		(func: (closeLocationPicker: () => void) => GeometryPickerConfig) => {
			setConfig(func(close))
			onOpenChange?.(true)
		},
		[close, onOpenChange],
	)

	return (
		<GeometryPickerContext value={open}>
			{children}
			{config && (
				<GeometryPickerOverlay
					open
					initialGeometry={config.initialGeometry}
					onSave={config.onSave}
					onCancel={config.onCancel}
				/>
			)}
		</GeometryPickerContext>
	)
})
GeometryPickerProvider.displayName = "GeometryPickerProvider"
